exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".list-item-cell{display:block;padding:7px 16px 7px 0}.list-item-cell.loading{opacity:0}.list-item-cell .lic-label{font-size:11px;color:#979892;line-height:1.3em}.list-item-cell .lic-content{text-overflow:ellipsis;overflow:hidden}.list-item-cell.pre{white-space:pre}", ""]);

